module.exports = __webpack_public_path__ + "static/img/Contact.8a003d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact.png
// module id = QCTk
// module chunks = 0